import { fromZonedTime } from "date-fns-tz";
import { useState } from "react";

import { DaysPicker } from "./days-picker";
import { MonthPicker } from "./month-picker";
import { WeekDay } from "../../../../types";
import { convertToZonedTime } from "../../../../utils";

type DatePickerProps = {
  heading?: string;
  selectedDate: string | undefined | null;
  startDate?: string;
  toDate?: string;
  excludingWeekDays?: WeekDay[];
  excludingDates?: string[];
  disabled?: boolean;
  viewingTimezone?: string | null;
  language?: string;
  onChange: (date: string) => void;
};

export const DatePicker = ({
  heading,
  selectedDate,
  startDate,
  toDate,
  excludingWeekDays,
  excludingDates,
  disabled,
  viewingTimezone,
  language,
  onChange,
}: DatePickerProps) => {
  const [{ year, month }, setYearMonth] = useState(() => {
    const initialDateInUtc = selectedDate
      ? fromZonedTime(selectedDate, viewingTimezone || "UTC")
      : new Date();
    const initialDateInViewingTimezone = convertToZonedTime(
      initialDateInUtc,
      viewingTimezone,
    );

    return {
      year: initialDateInViewingTimezone.getFullYear(),
      month: initialDateInViewingTimezone.getMonth(),
    };
  });

  return (
    <div
      className="flex flex-col max-w-[28.2rem] gap-medium"
      data-testid="intake-date-picker"
    >
      {heading && (
        <div className="mb-[0.6rem] ml-[0.6rem] text-ui font-medium">
          {heading}
        </div>
      )}
      <MonthPicker
        year={year}
        month={month}
        onChange={setYearMonth}
        disabled={disabled}
        viewingTimezone={viewingTimezone}
        language={language}
      />
      <DaysPicker
        selectedDate={selectedDate}
        year={year}
        month={month}
        startDate={startDate}
        toDate={toDate}
        excludingWeekDays={excludingWeekDays}
        excludingDates={excludingDates}
        onChange={onChange}
        disabled={disabled}
        viewingTimezone={viewingTimezone}
        language={language}
      />
    </div>
  );
};
